import { Button, Card, Checkbox, Form, Input, message, Modal } from "antd";
import Router from "../..";
import { useUserStore } from "../../../stores/userStore";
import { VALIDATION_MESSAGES, validators } from "../../utils/Regex";
import { useState } from "react";

const UNREGISTER_REASON_OPTIONS = [
  {
    value: "서비스를 자주 이용하지 않아요",
    label: "서비스를 자주 이용하지 않아요",
  },
  {
    value: "원하는 캠페인을 찾기 어려워요",
    label: "원하는 캠페인을 찾기 어려워요",
  },
  {
    value: "서비스 이용이 불편해요",
    label: "서비스 이용이 불편해요",
  },
  {
    value: "개인정보가 걱정돼요",
    label: "개인정보가 걱정돼요",
  },
  {
    value: "기타",
    label: "기타",
  },
];

const UNREGISTER_REASON_DETAIL_VALUE = "기타";

export const Setting = () => {
  const [form] = Form.useForm();
  const { userInfo } = useUserStore();
  const [changePwMode, setChangePwMode] = useState(false);
  const [unregisterMode, setUnregisterMode] = useState(false);

  const handleChangePassword = async () => {
    const values = await form.validateFields([
      "currentPassword",
      "newPassword",
      "confirmNewPassword",
    ]);

    // 정규식 검증
    if (!validators.password(values.newPassword)) {
      message.error(VALIDATION_MESSAGES.password.invalid);
      return;
    }

    const ok = await Router.Api.changePassword({
      currentPassword: values.currentPassword,
      newPassword: values.newPassword,
    });
    if (ok) {
      form.resetFields([
        "currentPassword",
        "newPassword",
        "confirmNewPassword",
      ]);
      setChangePwMode(false);
    }
  };

  const handleUnregister = async () => {
    const isOwnPlatform = userInfo?.user_info?.platform === "own";
    const fields = ["unregisterReason", "unregisterReasonDetail"];

    if (isOwnPlatform) {
      fields.push("unregisterPassword", "unregisterPasswordConfirm");
    }

    let values;
    try {
      values = await form.validateFields(fields);
    } catch {
      return;
    }
    const selectedReasons = values.unregisterReason ?? [];
    const reasonDetail = values.unregisterReasonDetail?.trim();
    const reasonText = selectedReasons
      .map((reason) =>
        reason === UNREGISTER_REASON_DETAIL_VALUE && reasonDetail
          ? `${reason}: ${reasonDetail}`
          : reason
      )
      .join(", ");
    const password = isOwnPlatform
      ? values.unregisterPassword
      : `geumbada${userInfo.user_info.oauth_id}`;

    Modal.confirm({
      title: "계정을 영구적으로 삭제하시겠습니까?",
      content:
        "이 작업은 실행 취소할 수 없습니다. 계정이 영구적으로 삭제됩니다. 모든 업체 정보가 삭제되고 이 계정이 제거됩니다.",
      okText: "예",
      cancelText: "아니오",
      onCancel() {
        return;
      },
      async onOk() {
        await Router.Api.unregister({
          password,
          reason: reasonText,
        });
      },
    });
  };

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">계정 설정</h2>
      <Card className="w-full max-w-[600px] border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)]">
        <Form
          form={form}
          layout="vertical"
          initialValues={userInfo?.user_info || {}}
          requiredMark={false}
        >
          {userInfo?.user_info?.platform === "own" && (
            <div className="mb-6">
              <div className="mb-4">비밀번호 변경하기</div>
              {changePwMode ? (
                <>
                  <div className="rounded-[18px] border border-[#e8ecf1] bg-[#fbfcfd] px-5 py-5">
                    <div className="mb-4">
                      <p className="text-[17px] font-bold tracking-[-0.03em] text-[#171717]">
                        새 비밀번호 설정
                      </p>
                    </div>
                    <Form.Item
                      name="currentPassword"
                      rules={[
                        {
                          required: true,
                          message: "현재 비밀번호를 입력해주세요.",
                        },
                      ]}
                      className="mb-2"
                    >
                      <Input.Password placeholder="현재 비밀번호" />
                    </Form.Item>
                    <Form.Item
                      name="newPassword"
                      rules={[
                        {
                          required: true,
                          message: "새 비밀번호를 입력해주세요.",
                        },
                      ]}
                      className="mb-2"
                    >
                      <Input.Password placeholder="새 비밀번호" />
                    </Form.Item>
                    <Form.Item
                      name="confirmNewPassword"
                      dependencies={["newPassword"]}
                      rules={[
                        {
                          required: true,
                          message: "새 비밀번호 확인을 입력해주세요.",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue("newPassword") === value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("비밀번호 확인이 일치하지 않습니다.")
                            );
                          },
                        }),
                      ]}
                      className="mb-2"
                    >
                      <Input.Password placeholder="새 비밀번호 확인" />
                    </Form.Item>
                  </div>
                  <div className="flex mt-4 gap-2.5">
                    <Button
                      className="hover:!border-[#171717] hover:!text-[#171717] hover:!shadow-none"
                      onClick={() => {
                        form.resetFields([
                          "currentPassword",
                          "newPassword",
                          "confirmNewPassword",
                        ]);
                        setChangePwMode(false);
                      }}
                    >
                      취소
                    </Button>
                    <Button
                      className="!bg-[#171717] hover:!bg-[#171717]"
                      type="primary"
                      onClick={() => {
                        handleChangePassword();
                      }}
                    >
                      변경 완료
                    </Button>
                  </div>
                </>
              ) : (
                <Button
                  className="!border-[#171717] !text-[#171717] hover:!border-[#171717] hover:!text-[#171717]"
                  onClick={() => setChangePwMode(true)}
                >
                  비밀번호 변경하기
                </Button>
              )}
            </div>
          )}

          <div>
            <div
              className="mb-4 cursor-pointer"
              onClick={() => {
                setUnregisterMode(true);
              }}
            >
              회원 탈퇴
            </div>
            {unregisterMode && (
              <>
                <div className="mb-5 rounded-[18px] border border-[#e8ecf1] bg-[#fbfcfd] px-5 py-5">
                  <div className="mb-4 flex items-start gap-3">
                    <div>
                      <p className="text-[17px] font-bold tracking-[-0.03em] text-[#171717]">
                        탈퇴 사유를 선택해주세요
                      </p>
                      <p className="mt-1 text-[13px] leading-relaxed text-[#6b7280]">
                        해당되는 사유를 모두 선택해 주세요.
                      </p>
                    </div>
                  </div>

                  <Form.Item
                    name="unregisterReason"
                    rules={[
                      {
                        required: true,
                        message: "탈퇴 사유를 선택해 주세요.",
                      },
                    ]}
                    className="mb-4"
                  >
                    <Checkbox.Group className="w-full">
                      <div className="w-full overflow-hidden rounded-[14px] border border-[#e6ebf0] bg-white">
                        {UNREGISTER_REASON_OPTIONS.map((reason) => (
                          <Checkbox
                            key={reason.value}
                            value={reason.value}
                            className="m-0 !flex !w-full items-center border-b border-[#eef2f6] px-4 py-3 text-[14px] font-medium text-[#2d333a] transition-colors last:border-b-0 hover:bg-[#f7f8fa] hover:text-[#111111] [&_.ant-checkbox]:mr-3 [&_.ant-checkbox-label]:flex-1"
                          >
                            {reason.label}
                          </Checkbox>
                        ))}
                      </div>
                    </Checkbox.Group>
                  </Form.Item>

                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.unregisterReason !==
                        currentValues.unregisterReason ||
                      prevValues.unregisterReasonDetail !==
                        currentValues.unregisterReasonDetail
                    }
                  >
                    {({ getFieldValue }) =>
                      getFieldValue("unregisterReason")?.includes(
                        UNREGISTER_REASON_DETAIL_VALUE
                      ) ? (
                        <div>
                          <Form.Item
                            name="unregisterReasonDetail"
                            rules={[
                              {
                                required: true,
                                whitespace: true,
                                message: "탈퇴 사유를 입력해 주세요.",
                              },
                            ]}
                            className="mb-0"
                          >
                            <Input.TextArea
                              placeholder="탈퇴 사유를 작성해주세요."
                              maxLength={100}
                              rows={3}
                              className="resize-none rounded-xl border-[#e5e9ef] bg-white text-[14px] shadow-none"
                            />
                          </Form.Item>
                          <div className="mt-1.5 text-right text-[12px] font-medium text-[#9ca3af]">
                            {
                              String(
                                getFieldValue("unregisterReasonDetail") ?? ""
                              ).length
                            }
                            /100
                          </div>
                        </div>
                      ) : null
                    }
                  </Form.Item>
                </div>

                {userInfo?.user_info?.platform === "own" && (
                  <div className="mb-6 rounded-[18px] border border-[#e8ecf1] bg-[#fbfcfd] px-5 py-5">
                    <div className="mb-4 flex items-start gap-3">
                      <div>
                        <p className="text-[17px] font-bold tracking-[-0.03em] text-[#171717]">
                          본인 확인
                        </p>
                        <p className="mt-1 text-[13px] leading-relaxed text-[#6b7280]">
                          본인 확인을 위해 현재 비밀번호를 입력해 주세요.
                        </p>
                      </div>
                    </div>

                    <Form.Item
                      name="unregisterPassword"
                      rules={[
                        {
                          required: true,
                          message: "현재 비밀번호를 입력해주세요.",
                        },
                      ]}
                      className="mb-2"
                    >
                      <Input.Password placeholder="현재 비밀번호" />
                    </Form.Item>

                    <Form.Item
                      name="unregisterPasswordConfirm"
                      dependencies={["unregisterPassword"]}
                      rules={[
                        {
                          required: true,
                          message: "비밀번호 확인을 입력해주세요.",
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue("unregisterPassword") === value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              new Error("비밀번호 확인이 일치하지 않습니다.")
                            );
                          },
                        }),
                      ]}
                      className="mb-0"
                    >
                      <Input.Password placeholder="비밀번호 확인" />
                    </Form.Item>
                  </div>
                )}

                <div className="flex gap-2.5">
                  <Button
                    onClick={() => {
                      form.resetFields([
                        "unregisterReason",
                        "unregisterReasonDetail",
                        "unregisterPassword",
                        "unregisterPasswordConfirm",
                      ]);
                      setUnregisterMode(false);
                    }}
                  >
                    취소
                  </Button>
                  <Button danger onClick={handleUnregister}>
                    탈퇴하기
                  </Button>
                </div>
              </>
            )}
          </div>
        </Form>
      </Card>
    </div>
  );
};
